<template>
  <div class="slideshow">
  
    <flickity class="flickity" ref="flickity" :options="flickityOptions">
        <!-- TV4 Play -->
        <div class="carousel-cell">
            <div class="bg nr-cc medium mob-medium-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FTV4-1-min.png?alt=media&token=9ac0739d-381a-4155-9279-447595fd18ec');"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-medium-h" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FTV4-2-min.png?alt=media&token=2562c581-097a-435b-bc67-5c8b73d24927');"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-medium-h" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FTV4-3-min.png?alt=media&token=3ca9f69d-8dbd-4011-a378-763809d65ea3')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc medium mob-medium-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FTV4-5-min.png?alt=media&token=8e19636a-1156-4c1b-9a13-fb38d03b8bff')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FTV4-6-min.png?alt=media&token=4a86e8f5-59bf-48a1-97e5-de61d1d8fd0e')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FTV4-7-min.png?alt=media&token=8f6421e8-82d5-4623-8ffb-06f185c3f8bd')"></div>
        </div>
        <!-- W Rast -->
        <div class="carousel-cell">
            <div class="bg nr-cc cover mob-medium-h" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FRast-min.png?alt=media&token=1744cc8f-d9c0-4cb2-a057-12013eddd2a3')"></div>
        </div>
        <!-- SF -->
        <div class="carousel-cell">
            <div class="bg nr-cc medium mob-medium-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FSF-1-min.png?alt=media&token=263c5daf-fb24-4250-a623-f3ff69bae44b')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc medium mob-medium-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FSF-2-min.png?alt=media&token=7da13619-38ce-400a-a629-65f7d04f8f11')"></div>
        </div>
        <!-- Revir -->
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-medium-h" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FRevir-1.png?alt=media&token=3c2be4a8-cf94-4e1b-961e-296a71436af7')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-medium-h2" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FRevir-1-min.png?alt=media&token=05f2d633-ff8c-428c-a331-70108b1d1504')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc cover mob-medium-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FRevir-2-min.png?alt=media&token=00cc9998-8594-4e52-8fed-893a47fd6cc6')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc cover mob-medium-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FRevir-3-min.png?alt=media&token=e83623fe-c233-44d2-810b-ce87a2827bd8')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc cover mob-medium-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FRevir-4-min.png?alt=media&token=b1882db6-83e8-42bf-9741-ab7188a5cfee')"></div>
        </div>
        <!-- Bambuser -->
        <div class="carousel-cell">
            <div class="bg nr-cc cover mob-medium-h" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FBambuser-1.png?alt=media&token=86612046-d3f1-492f-ba7b-179a0a7cd4a2')"></div>
        </div>
        <!-- Coop -->
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FCoop-1.png?alt=media&token=bca46cd3-ab70-4c39-8e0c-d9fd71243249')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FCoop-2.png?alt=media&token=56a1443f-fc28-4bc3-a532-bfa09610a3b4')"></div>
        </div>
        <!-- Formation -->
        <div class="carousel-cell">
            <div class="bg nr-cc cover mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FFormation-2.png?alt=media&token=68199a44-05d9-44b1-a4a2-f7616b4c2791')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc cover mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FFormation-3.png?alt=media&token=a14ad977-3c26-4fea-a79f-08e41891bc20')"></div>
        </div>
        <!-- C More -->
        <div class="carousel-cell">
            <div class="bg nr-cc cover mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FCMore-1.png?alt=media&token=f87a3765-1359-4b23-8ea4-dd1cdb99ea4c')"></div>
        </div>
        <!-- Cameralink -->
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FCameralink-1.png?alt=media&token=5d6e2395-7316-4a61-93c6-1b8526f38ace')"></div>
        </div>
        <!-- Emote -->
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FEmote-1.png?alt=media&token=e3bf1e0c-da88-4bd8-8c4c-f5fcb6f95ba6')"></div>
        </div>
        <div class="carousel-cell">
            <div class="bg nr-cc full-w mob-full-w" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/images%2FEmote-2.png?alt=media&token=0be5e43d-bab1-43a4-a8ce-09598b5c127c')"></div>
        </div>
    </flickity>

    <div class="buttons-wrap">
        <div class="prev" @click="previous()"></div>
        <div class="next" @click="next()"></div>
    </div>
    
  </div>
</template>

<script>
import Flickity from 'vue-flickity';

export default {
    name: 'Slideshow',
    props: {
        msg: String
    },
    components: {
        Flickity
    },
    data () {
        return {
            flickityOptions: {
                initialIndex: 0,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                autoPlay: 5000,
                pauseAutoPlayOnHover: false,
                resize: true
            }
        }
    },
    methods: {
        next() {
            this.$refs.flickity.next();
        },
        
        previous() {
            this.$refs.flickity.previous();
        }
    }
}
</script>

<style scoped lang="scss">
@import "../scss/_vars.scss";
@import "../scss/_mixins.scss";

.slideshow {
    position: relative;
    background-color: $white;
    height: 100vh;
    width: 100vw;
    color: $black;
    p {
        color: $black;
    }
    .flickity {
        position: absolute;
        background: $black;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        .carousel-cell {
            width: 100%;
            height: 100%;
            counter-increment: gallery-cell;
            .bg {
                width: 100%;
                height: 100%;
            }
            .nr-cc {
                background: no-repeat center center;
            }
            .cover {
                background-size: cover;
            }
            .medium {
                background-size: 70%;
            }
            .full-w {
                background-size: 100%;
            }
            @media #{$mobile} {
                .mob-medium-w {
                    background-size: 90%;
                }
                .mob-medium-h {
                    background-size: auto 40%;
                }
                .mob-medium-h2 {
                    background-size: auto 50%;
                }
                .mob-full-w {
                    background-size: 100%;
                }
                .mob-full-h {
                    background-size: auto 100%;
                }
            }
        }

        /* cell number */
        // .carousel-cell:before {
            // display: block;
            // text-align: center;
            // content: counter(gallery-cell);
            // font-size: 80px;
            // color: white;
        // }
    }
    .buttons-wrap {
        display: flex;
        width: 100%;
        .prev, .next {
            position: relative;
            width: 50%;
            height: 100vh;
        }
        .prev {
            cursor: url("../assets/cursors/prev.svg") 0 0, e-resize;
            cursor: -webkit-image-set(url("../assets/cursors/prev.svg") 1x, url("../assets/cursors/prev.svg") 2x) 0 0, e-resize;    
        }
        .next {
            cursor: url("../assets/cursors/next.svg") 0 0, e-resize;
            cursor: -webkit-image-set(url("../assets/cursors/next.svg") 1x, url("../assets/cursors/next.svg") 2x) 0 0, e-resize;
        }
        @media #{$mobile} {
            // display: none;
        }
    }
    
}

</style>
